var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2578 4.27419H2.53985L5.14359 1.74026C5.43412 1.45748 5.43524 0.997937 5.14608 0.71382C4.85692 0.429667 4.38697 0.428615 4.09644 0.711353L0.218365 4.48555C0.218106 4.48577 0.21792 4.48602 0.217698 4.48624C-0.0720894 4.76901 -0.0730171 5.23004 0.217623 5.51376C0.217883 5.51398 0.218069 5.51423 0.218291 5.51445L4.09637 9.28865C4.38686 9.57135 4.85681 9.57037 5.146 9.28618C5.43516 9.00206 5.43405 8.54252 5.14352 8.25974L2.53985 5.72581H18.2578C18.6677 5.72581 19 5.40086 19 5C19 4.59914 18.6677 4.27419 18.2578 4.27419Z",
    fill: "#038E83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBackArrow);
export default __webpack_public_path__ + "static/media/full-back-arrow.ba2f8b42.svg";
export { ForwardRef as ReactComponent };